import { Branch } from '../types/branch';
import { Coupon, UserCouponWithCouponAndUsesCount } from '../types/coupon';
import { ExternalUserShort, ExternalUser, ExternalUserWithCoupons } from '../types/externalUser';
import { ExerciseShort } from '../types/Fisiofit/exercise';
import { ReservationType } from '../types/reservationType';
import { Role } from '../types/role';
import { User } from '../types/user';
import { capitalize } from './textUtils';

export const ALL_SELECT_OPTION = 'all';

export const getRoleOptions = (roles?: Role[]) => {
  return roles?.map((role) => ({
    label: role.name,
    value: role.id,
  }));
};

export const getBranchOptions = (branches: Branch[] | undefined, selectAll: boolean) => {
  return [
    ...(selectAll ? [{ label: 'Todas las sucursales', value: ALL_SELECT_OPTION }] : []),
    ...(branches?.map((branch) => ({
      label: branch.name,
      value: branch.id,
    })) || []),
  ];
};

export const getReservationTypeOptions = (reservationTypes: ReservationType[], selectAll: boolean) => {
  return [
    ...(selectAll ? [{ label: 'Todos los tipos de reserva', value: ALL_SELECT_OPTION }] : []),
    ...reservationTypes.map((reservationType) => ({
      label: capitalize(reservationType.name),
      value: reservationType.name,
    })),
  ];
};

export const getClientTypeOptions = (clientTypes: { [key: string]: unknown } | undefined, selectAll: boolean) => {
  return [
    ...(selectAll ? [{ label: 'Todos los tipos de cliente', value: ALL_SELECT_OPTION }] : []),
    ...Object.entries(clientTypes ?? {}).map(([key]) => ({
      label: capitalize(key),
      value: key,
    })),
  ];
};

export const getExerciseOptions = (exercises?: ExerciseShort[], muscleGroups?: string[], categories?: string[]) => {
  let filteredExercises = exercises;

  if (muscleGroups?.length) {
    filteredExercises = filteredExercises?.filter((exercise) =>
      exercise.muscleGroups?.some((group) => muscleGroups.includes(group)),
    );
  }

  if (categories?.length) {
    filteredExercises = filteredExercises?.filter((exercise) =>
      exercise.categories?.some((category) => categories.includes(category)),
    );
  }

  return filteredExercises?.map((exercise) => ({
    label: exercise.name,
    value: exercise.id,
  }));
};

export const getOrgCouponOptions = (coupons?: Coupon[]) => {
  return coupons?.map((coupon) => ({
    label: coupon.name,
    value: coupon.id,
  }));
};

export const getUserCouponOptions = (
  coupons?: UserCouponWithCouponAndUsesCount[],
  currentReservationCoupon?: UserCouponWithCouponAndUsesCount,
) => {
  // The reservation's own coupon stays selectable when the active list leaves it out: inactive, or spent (no uses left).
  const keepCurrent =
    currentReservationCoupon &&
    (!currentReservationCoupon.isActive || currentReservationCoupon.usesRemaining <= 0) &&
    !coupons?.some((coupon) => coupon.id === currentReservationCoupon.id);
  const finalOptions = [...(coupons ?? []), ...(keepCurrent ? [currentReservationCoupon] : [])];
  return finalOptions?.map((coupon) => ({
    label: coupon.coupon.name,
    value: coupon.id,
    ...coupon,
  }));
};

export const getUserOptions = (users?: (ExternalUserWithCoupons | ExternalUserShort | ExternalUser | User)[]) => {
  return users?.map((user) => ({
    label: `${user.name} ${user.surnames}`,
    value: user.id,
    ...user,
  }));
};
